export namespace SubscriptionConst {
  export enum Subscription {
    subscriptionTierFree = 'free',
    subscriptionTierTeam = 'team',
    subscriptionTierOrganization = 'organization',
    ManagedByTypeTeamManager = 'team_manager',
    ManagedByTypeJigStaff = 'jig_staff',
    pricingSet_2020_01 = 'set_2020_01',
    pricingSet_2022_07 = 'set_2022_07',
    pricingSet_2023_02 = 'set_2023_02',
    pricingSet_2023_06 = 'set_2023_06',
    defaultSeatsIncludedInTier = '-',
    defaultMaxJigsInTier = 0,
    defaultMaxJigsPerInTier = '-',
    embedQueryParamDefaultLang = 'en-US',
  }

  export const subscriptionTiers: Subscription[] = [
    Subscription.subscriptionTierFree,
    Subscription.subscriptionTierTeam,
    Subscription.subscriptionTierOrganization,
  ]

  export const subscriptionManagedByTypes: {
    value: Subscription
    text: string
  }[] = [
    {
      value: Subscription.ManagedByTypeTeamManager,
      text: 'Team manager',
    },
    {
      value: Subscription.ManagedByTypeJigStaff,
      text: 'Jig staff',
    },
  ]

  export const pricingSets: Subscription[] = [
    Subscription.pricingSet_2020_01,
    Subscription.pricingSet_2022_07,
    Subscription.pricingSet_2023_02,
    Subscription.pricingSet_2023_06,
  ]

  export enum Features {
    AVPFullAccessFeatureGate = 'ViewingGate_MAR_2024',
    AVPFeaturePullApartKey = 'AVP_Feature_PullApart',
  }

  export const AVPFullAccessFeatureGate = 'ViewingGate_MAR_2024'
  export const AVPFeaturePullApartKey = 'AVP_Feature_PullApart'
  export const defaultSubscription = {
    AdditionalSeats: 0,
    AllowCustomBranding: false,
    AllowMovoJigs: false,
    AllowJigStats: false,
    AllowPasswordJigs: false,
    AllowPrivateJigs: false,
    AllowWorkshopPropertyPanel: false,
    ManagedByType: '',
    MaxJigs: -1,
    MaxJigsCountPer: '',
    ModelUploadMaxSizeMB: -1,
    OverLimitWarningDismissableUntil: '',
    OverLimitWarningShowContactUs: false,
    PricingSet: SubscriptionConst.Subscription.pricingSet_2023_06,
    SeatsIncludedInTier: -1,
    StripeCustomerId: '',
    StripeSubscriptionId: '',
    SubscriptionFeatures: {
      avp: { enabled: false },
      movo: { enabled: false },
      stats: {
        jigStats: { enabled: false },
      },
      Available: {},
      CustomFeatures: {},
    },
    TeamStorageLimitMB: -1,
    TierType: '',
    TierTypeDisplayName: '',
    ViewJigStepMax: -1,
    RestrictedJigCopyableByTypes: [],
  }

  export const CustomFeaturesLabels: Record<string, string> = {
    MaxJigs: 'Max Jigs',
    TeamStorageLimitMB: 'Team library storage (MB)',
    ViewJigStepMax: 'Maximum steps per Jig',
    UniversalAR: 'Universal AR',
    VIP: 'VIP Customer', // placeholder for new field
  }

  export enum FlexFeatureFieldType {
    bool = 'bool',
    int = 'int',
    float = 'float',
    string = 'string',
    string_array = '[]string',
  }

  export enum FlexFeatureFieldOperators {
    gte = '>=',
    gt = '>',
    eq = '==',
    lt = '<',
    lte = '<=',
    gte_txt = 'gte',
    gt_txt = 'gt',
    eq_txt = 'eq',
    lt_txt = 'lt',
    lte_txt = 'lte',
  }
}
